import type { Locale } from '../types';

export const ensureLeadingSlash = (path: string) => (path.startsWith('/') ? path : `/${path}`);
export const ensureLocalePrefix = (path: string, locale: Locale) => {
  const prefix = locale === 'en-US' ? '' : path.startsWith(`/${locale}`) ? '' : `/${locale}`;
  return `${prefix}${ensureLeadingSlash(path)}`;
};

/**
 * Public origin of the site (no trailing slash).
 *
 * `DOMAIN` is set per Netlify site and is what the GraphQL layer uses for the
 * canonical fallback and the sitemap; `next.config.js` exposes it to the bundle.
 * Falls back to production so Storybook and tests still produce a real URL.
 */
export const getSiteOrigin = () => (process.env.DOMAIN || 'https://sensortower.com').replace(/\/+$/, '');

/**
 * Contentful serves asset URLs protocol-relative (`//images.ctfassets.net/...`).
 * Structured data needs a real absolute URL, so give those a scheme; anything that
 * already has one is left as it is. Mirrors what `contentfulLoader` does for `next/image`.
 */
export const ensureAbsoluteUrl = (url: string) => (url.startsWith('//') ? `https:${url}` : url);

/** Absolute site URL for `path`, with the Next i18n locale prefix applied. */
export const getSiteUrl = (path: string, locale: Locale) => `${getSiteOrigin()}${ensureLocalePrefix(path, locale)}`;

/**
 * Full-page navigation helper — keeps location mutation outside React components.
 *
 * Exported on an object rather than as a bare function so tests can stub it:
 * `window.location.assign` is a non-writable, non-configurable own property in
 * modern browsers, so it cannot be reassigned or spied on directly.
 */
export const navigation = {
  redirectToPath: (path: string, locale: Locale) => {
    window.location.assign(ensureLocalePrefix(path, locale));
  },
};
